import { create } from "zustand";
import type {
  PpsPaymentOption,
  PpsPaymentMethodDetails,
} from "../types";

interface PaymentPlansState {
  selectedPaymentOption?: PpsPaymentOption;
  selectedPaymentMethod?: PpsPaymentMethodDetails;
  actions: {
    setSelectedPaymentOption: (paymentOption: PpsPaymentOption) => void;
    setSelectedPaymentMethod: (
      paymentMethod: PpsPaymentMethodDetails | undefined,
    ) => void;
  };
}

const usePaymentPlansStore = create<PaymentPlansState>((set) => ({
  selectedPaymentOption: undefined,
  selectedPaymentMethod: undefined,
  actions: {
    setSelectedPaymentOption: (paymentOption: PpsPaymentOption) =>
      set({ selectedPaymentOption: paymentOption }),
    setSelectedPaymentMethod: (
      paymentMethod: PpsPaymentMethodDetails | undefined,
    ) => set({ selectedPaymentMethod: paymentMethod }),
  },
}));

export const useSelectedPaymentOption = (): PpsPaymentOption | undefined =>
  usePaymentPlansStore((state) => state.selectedPaymentOption);

export const useSelectedPaymentMethod = (): PpsPaymentMethodDetails | undefined =>
  usePaymentPlansStore((state) => state.selectedPaymentMethod);

export const usePaymentPlansActions = (): PaymentPlansState["actions"] =>
  usePaymentPlansStore((state) => state.actions);
